import { connect } from 'react-redux';
import { changeParticipateStep, getParticipateForm } from 'project/ducks/form';
import { getProject } from 'project/ducks/project';
import { getProjectEntries } from 'project/ducks/entries';
import ParticipateButtons from 'project/components/participate_form/form_buttons';

function mapButtonStateToProps(state) {
  return {
    currentStep: getParticipateForm(state).currentStep,
    entries: getProjectEntries(state),
    project: getProject(state),
    user: state.user.profile_data,
  };
}

export default connect(mapButtonStateToProps, {
  changeStep: changeParticipateStep,
})(ParticipateButtons);



// WEBPACK FOOTER //
// ./project/containers/participate_buttons.jsx